import React from "react";
import PropTypes from "prop-types";
import responseTypes from "../../utils/responseTypes";
import CustomerPersonalDetail from "./CustomerPersonalDetail";

const InfoItem = ({ label, value }) => (
  <div className="mb-3">
    <small className="text-muted text-uppercase fw-semibold" style={{ fontSize: "0.75rem", letterSpacing: "0.05em" }}>
      {label}
    </small>
    <p className="mb-0 fw-medium">{value}</p>
  </div>
);

InfoItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const JobDetails = ({ job, options }) => {
  const renderJobInfo = () => {
    let combiSwapText = "";
    if (job.jobDetail.convertToCombi === true) {
      combiSwapText = "Yes";
    } else if (job.boiler.type != responseTypes().BOILER_COMBI) {
      combiSwapText = "No";
    } else {
      combiSwapText = "Replacing a combi";
    }

    const items = [
      { label: "Current Boiler", value: job.jobDetail.currentBoilerType },
      { label: "Convert to Combi", value: combiSwapText },
      { label: "Boiler Move Required", value: job.jobDetail.boilerMove === true ? "Yes" : "No" },
    ];

    if (job.jobDetail.boilerMove === true) {
      items.push({ label: "Current Boiler Location", value: job.jobDetail.currentBoilerLocation });
      items.push({ label: "New Boiler Location", value: job.jobDetail.newBoilerLocation });
    }

    if (job.jobDetail.currentFlueExit.length > 0) {
      items.push({ label: "Flue Move Required", value: "No" });
      items.push({ label: "Flue Exit", value: job.jobDetail.currentFlueExit });
    } else {
      items.push({ label: "Flue Move Required", value: "Yes" });
      items.push({ label: "New Flue Exit", value: job.jobDetail.newFlueExit });
    }

    if (job.jobDetail.roofType.length > 0) {
      items.push({ label: "Roof Type", value: job.jobDetail.roofType });
    }
    if (job.jobDetail.roofFlueExitPosition.length > 0) {
      items.push({ label: "Roof Flue Exit Position", value: job.jobDetail.roofFlueExitPosition });
    }
    if (job.jobDetail.flueDoorWindowDistance.length > 0) {
      items.push({ label: "Flue Distance from Opening", value: job.jobDetail.flueDoorWindowDistance });
    }

    return items;
  };

  const houseInfo = [
    { label: "House Type", value: job.house.houseType },
    ...(job.house.floorNumber.length > 0 ? [{ label: "Floor Number", value: job.house.floorNumber }] : []),
    { label: "Fuel Type", value: job.house.fuelType },
    {
      label: "Bedrooms",
      value: `${job.house.bedrooms} bedroom${job.house.bedrooms != responseTypes().NUMBER_ONE ? "s" : ""}`,
    },
    {
      label: "Bathtubs",
      value: `${job.house.bathtubs} bath tub${job.house.bathtubs != responseTypes().NUMBER_ONE ? "s" : ""}`,
    },
    {
      label: "Showers",
      value: `${job.house.showers} shower${job.house.showers != responseTypes().NUMBER_ONE ? "s" : ""}`,
    },
  ];

  return (
    <div className="card-body">
      <div className="card-text">
        <div className="row g-3">
          {options.showPersonalInfo === true ? <CustomerPersonalDetail job={job} /> : ""}
          <div className={options.showPersonalInfo === true ? "col-md-4" : "col-md-6"}>
            <div className="bg-light rounded p-3 mb-3">
              <p className="fw-bold mb-3 border-bottom pb-2">Boiler</p>
              <InfoItem
                label="Make / Model / Output"
                value={`${job.boiler.make} ${job.boiler.model} ${job.boiler.output}kW (${job.boiler.type})`}
              />
            </div>
            <div className="bg-light rounded p-3">
              <p className="fw-bold mb-3 border-bottom pb-2">House Info</p>
              {houseInfo.map((item) => (
                <InfoItem key={item.label} label={item.label} value={item.value} />
              ))}
            </div>
          </div>
          <div className={options.showPersonalInfo === true ? "col-md-4" : "col-md-6"}>
            <div className="bg-light rounded p-3 h-100">
              <p className="fw-bold mb-3 border-bottom pb-2">Job Info</p>
              {renderJobInfo().map((item) => (
                <InfoItem key={item.label} label={item.label} value={item.value} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

JobDetails.propTypes = {
  job: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
};

export default JobDetails;
